import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";
import { Conf_Message_Allowed_Extension, MAX_LENGTH } from "../../../../../constants/external-constants";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { TRANSLATIONS as translation,  } from '../../../../../utils/constant.utils';
import { NoSubscription } from "../../../dashboard/no-subscription/no-subscription.component";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component"
import Translation  from "../../../../common/translation/translation.component";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ContractCommitment from "./contract-commitment/contract-commitment.component";
import BtnFileAttachement from "../../../../common/file-attachment/button-file-attachement.component";
import { FinanceContractFormActions } from "../../../../../store/external/finance/contract/contract-details.reducer";
import { bindActionCreators } from 'redux';
import { actions } from "react-redux-form";
import { DATA_TYPE } from "../../../../../constants/external-constants";
import { isObjectEqual, convertToDecimal } from "../../../../../utils/helpers.utils";
import store from "../../../../../store";
import CustomSearchableDropdownWrapper from "../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class ContractFormView extends Component {
    constructor(props) {
        super(props);
        this.ConfirmationModal = React.createRef();
        this.state = {
            viewDetailPage: false,
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isSaving: false,
            activeDropdown: null,
            originalPlanComponentData:{},
            isLoading: true,
            files: [],
        }
        this.UploadButton = React.createRef();
    }

     componentDidMount() {
         this.fetchContractData();
    }

     fetchContractData = async () => {
        const { getContractDropdownList, getVendorList, getServiceTypeList, isCreateNew, contractId, getContractFormDetails, getSelectedVendor, getSelectedServiceType } = this.props;

        if (!isCreateNew && contractId > 0) {
           await getContractFormDetails(contractId);
        }

       await getContractDropdownList();
        const { contract } = this.props.contractForm;

        let vendorName = '';
        let serviceTypeName = '';

        if (contract?.vendorDetailId) {
            vendorName = await getSelectedVendor(contract.vendorDetailId);
        }

        await getVendorList(1, vendorName);

        if (contract?.circuitTypeId) {
            serviceTypeName = await getSelectedServiceType(contract.circuitTypeId);
        }

         await getServiceTypeList(1, serviceTypeName);


        this.setState({ isLoading: false });
    }

    componentWillUnmount() {
        this.props.resetContractForm();
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '' || locale === undefined)
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    handleToggleDropdown = (index, isShow = false) => {
        this.setState(prevState => ({
            activeDropdown: prevState.activeDropdown === index && !isShow ? null : index
        }));
    }   

    onChangeVendorSelection(e) {
        const { getSelectedVendorCurrency } = this.props;

        if (e != null) {
            getSelectedVendorCurrency(e);
        }
    }

    handleButtonConfirmation = async (contractId, validate = 1) => {
        const { saveFinanceContract, contractForm, isCreateNew } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveFinanceContract(contractId, validate, this.state.fileNames);

        this.setState({
            isSaving: false
        });

        if (result.success === false) {
            if (result.isValid) {
                if (!isCreateNew) {
                    const confirmMessage = this.toLocaleLanguage("save_confirmation");
                    const modalTitle = this.toLocaleLanguage("call_save", false);
                    var confirmAction = () => this.handleButtonConfirmation(contractId, 0);
                    this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                    return;
                }
                else {
                    this.handleButtonConfirmation(contractId, 0);
                    return;
                }

            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                return;
            }
        }
        else if (result.success === true) {
            const modalMessage = result.message;
            const modalTitle = this.toLocaleLanguage("success_modal_title");

            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, modalTitle, modalMessage);
            this.setState({
                isLoading: true
            })
            this.fetchContractData();
            return;
        }
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { handleCloseForm, resetContractForm, getContractFormDetails } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && saveNotif.message === this.toLocaleLanguage("contract_created")) {
            handleCloseForm();
            resetContractForm();
        }
        if(!isShow && saveNotif.message === "Contract has been updated"){
            resetContractForm();
            getContractFormDetails(this.props.contractId);
        }

    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    fetchFileData = (val, action = "add") => {
        this.setState((prevState) => {
            let updatedFileNames = [...(prevState.fileNames || [])];

            if (action === "add") {
                updatedFileNames = [...updatedFileNames, ...val];
            } else if (action === "remove") {
                store.dispatch(actions.change("contractForm.contract.files",  [...val]));
                return { fileNames: [...val] };
            }

            store.dispatch(actions.change("contractForm.contract.files",  updatedFileNames));
            return { fileNames: updatedFileNames };
        });
    };

    disableSaveChanges = () => {
        const { $form, contractForm } = this.props
        const { contract, contractCommitment } = contractForm;
        const { contractCode,
            contractName,
            vendorDetailId,
            contractStatusId,
            circuitTypeId,
            termLength,
            evergreenStatusId,
            effectiveDate,
            expirationDate } = contract;

        const isFieldEmpty = !contractCode || !contractName || !vendorDetailId || !contractStatusId || !circuitTypeId ||
            !termLength || !evergreenStatusId || !effectiveDate || !expirationDate;


        if (isFieldEmpty) {
            return true;
        }

        const removeFiles = (obj, props) => {
            const newObj = { ...obj };
            props.forEach(p => delete newObj[p]);
            return newObj;
        };

        const excludedProps = ["files"];

        const cleanData = (obj) => {
            const cloned = JSON.parse(JSON.stringify(obj || {}));
            if (cloned.contract) {
                cloned.contract = removeFiles(cloned.contract, excludedProps);
            }
            return cloned;
        };

        const normalizeValue = (val) => {
            if (val === null || val === undefined) return "";
            if (typeof val === "number") return val.toFixed ? val.toFixed(2) : val;
            return val;
        };

        const normalizeObject = (obj, parentPath = "") => {
            if (obj === null || obj === undefined) return "";
            if (typeof obj !== "object") return normalizeValue(obj);

            if (Array.isArray(obj))
                return obj.map(item => normalizeObject(item, parentPath));

            const normalized = {};

            for (const key in obj) {
                if (!Object.hasOwn(obj, key)) continue;

                const fullPath = parentPath ? `${parentPath}.${key}` : key;
                const isUtilization =
                    fullPath.toLowerCase().includes("contract") &&
                    key.toLowerCase() === "utilization";

                if (isUtilization) {
                    let val = obj[key];

                    if (val === null || val === undefined || val === "") {
                        normalized[key] = "0.00";
                        continue;
                    }

                    const num = Number(val);
                    normalized[key] = isNaN(num) ? val : num.toFixed(2);
                    continue;
                }

                normalized[key] = normalizeObject(obj[key], fullPath);
            }

            return normalized;
        };

        const oldClean = cleanData($form.loadedValue);
        const newClean = cleanData(contractForm);

        const unchangedContractDetails =
            !$form.loadedValue ||
            isObjectEqual(
                normalizeObject(oldClean.contract),
                normalizeObject(newClean.contract)
            );

        const unchangedContractCommitment =
            !$form.loadedValue ||
            isObjectEqual(
                $form.loadedValue.contractCommitment,
                contractCommitment
            );
        const oldFiles = $form.loadedValue.contract.files;
        const newFiles = contract.files;

        const previous = oldFiles.map(x => x.fileName);
        const updated = newFiles.map(x => x.originalFileName || x.fileName);

        const hasFileChange =
            JSON.stringify(previous) !== JSON.stringify(updated);


        return (
            unchangedContractDetails &&
            unchangedContractCommitment &&
            !hasFileChange 
        );
    }
    convertToDecimal = (value) => {
        if (typeof value === "string") return value;
        const result = (Math.round(value * 100) / 100).toFixed(2);

        return result;
    }

    loadMoreVendor = (searchString) => {
        const { contractDetails, getVendorList } = this.props;

            getVendorList(contractDetails.vendorListPage + 1, searchString);
    }

    loadMoreCircuit = (searchString) => {
        const { contractDetails, getServiceTypeList } = this.props;

            getServiceTypeList(contractDetails.serviceListPage + 1, searchString);
    }
    handleSearchVendor = (query) => {        
        const {getVendorList} = this.props;
            getVendorList(1, query);
    }
    handleSearchCircuit = (query) => {        
        const {getServiceTypeList } = this.props;
            getServiceTypeList(1, query);
    }

    render() {
        const { isLoading } = this.state;
        const { contractDetails, contractForm, contractId } = this.props;
        const { contract, contractCommitment } = contractForm;
        const { contractCode,
            contractName,
            vendorDetailId,
            contractStatusId,
            circuitTypeId,
            termLength,
            evergreenStatusId,
            effectiveDate,
            expirationDate } = contract;

        const requiredFields = [
            contractCode,
            contractName,
            vendorDetailId,
            contractStatusId,
            circuitTypeId,
            termLength,
            evergreenStatusId,
            effectiveDate,
            expirationDate
        ];

        const enableSaveButton = requiredFields.some((field) => !field);

        return (
            <>
            {isLoading ? 
                <NoSubscription/> :
                <div className="add-plan-catalogue dispute-container contract-form-container">
                <div className="dispute-container details-field-container mb-3 capital-uppercase">

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"contract_id"} />}
                        value={contractForm.contract.contractCode}
                        fieldProp='contractForm.contract.contractCode'
                        maxLength={MAX_LENGTH.inputText}
                        disabled={false}
                        requiredField
                        placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"contract_name"} />}
                        value={contractForm.contract.contractName}
                        fieldProp='contractForm.contract.contractName'
                        maxLength={MAX_LENGTH.limit_255}
                        disabled={false}
                        requiredField
                        placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                    />

                    <CustomSearchableDropdownWrapper 
                        label={this.toLocaleLanguage("vendor")}
                        options={contractDetails.vendorList}
                        selected={contractForm.contract.vendorDetailId}
                        onChange={(e) => this.onChangeVendorSelection(e)}
                        requiredField
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='contractForm.contract.vendorDetailId'
                        tagName='tagName'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleSearchVendor}
                        onLoadMore={(val) => this.loadMoreVendor(val)}
                        isLoading={!this.props?.contractDetails?.isVendorListLoaded}
                        hasMore={contractDetails?.hasMoreVendor}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={`${this.toLocaleLanguage('currency')}`}
                        value={contractForm.contract.currency}
                        fieldProp='contractForm.contract.currency'
                        disabled={true}
                    />

                    <Select
                        className="form-select required"
                        label={<Translation translationKey={"contract_status"} />}
                        options={contractDetails.contractDropdownList?.ContractStatus}
                        value={contractForm.contract.contractStatusId}
                        placeholder={this.toLocaleLanguage('select_placeholder', false)}
                        isError={false}
                        fieldProp='contractForm.contract.contractStatusId'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                    />

                    <CustomSearchableDropdownWrapper 
                        label={this.toLocaleLanguage("service_type")}
                        options={contractDetails?.serviceList}
                        selected={contractForm.contract.circuitTypeId}
                        requiredField
                        placeholder={`${this.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='contractForm.contract.circuitTypeId'
                        tagName='tagName'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                        maxLength={MAX_LENGTH.limit_100}
                        onSearchChange={this.handleSearchCircuit}
                        onLoadMore={() => this.loadMoreCircuit()}
                        isLoading={!this.props?.contractDetails?.isServiceListLoaded}
                        hasMore={contractDetails?.hasMoreService}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"term_length"} />}
                        value={contractForm.contract.termLength}
                        fieldProp='contractForm.contract.termLength'
                        maxLength={MAX_LENGTH.inputText}
                        disabled={false}
                        requiredField
                        placeholder={this.toLocaleLanguage("enter_text_placeholder")}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"utilization"} />}
                        value={this.convertToDecimal(contractForm.contract.utilization)}
                        fieldProp='contractForm.contract.utilization'
                        inputType={DATA_TYPE.decimal}
                        disabled={false}
                        maxLength={MAX_LENGTH.limit_19}
                    />

                    <Select
                        className="form-select required"
                        label={<Translation translationKey={"evergreen_status"} />}
                        options={contractDetails.contractDropdownList?.EvergreenStatus}
                        value={contractForm.contract.evergreenStatusId}
                        placeholder={this.toLocaleLanguage('select_placeholder', false)}
                        isError={false}
                        fieldProp='contractForm.contract.evergreenStatusId'
                        optionLabelKey={{
                            Key: "Key",
                            Value: "Value"
                        }}
                    />

                    <DATEPICKER_OR
                        dateOnly={true}
                        additionalClass={"date-picker-main-container"}
                        label={<Translation translationKey={"effective_date"} />}
                        placeholder={`${this.toLocaleLanguage('select_date')}`}
                        startDate={contractForm.contract.effectiveDate}
                        selectedDate={(date) => this.props.FormChange("contractForm.contract.effectiveDate", date)}
                        isDisable={false}
                        requiredField={true}
                    />
                
                    <DATEPICKER_OR
                        dateOnly={true}
                        additionalClass={"date-picker-main-container"}
                        label={<Translation translationKey={"expiration_date"} />}
                        placeholder={`${this.toLocaleLanguage('select_date')}`}
                        startDate={contractForm.contract.expirationDate}
                        selectedDate={(date) => this.props.FormChange("contractForm.contract.expirationDate", date)}
                        isDisable={false}
                        requiredField={true}
                    />
                    <div className="file-upload-contract">

                    <BtnFileAttachement 
                        fileFormat={Conf_Message_Allowed_Extension}
                        fileSizeMB={9.537}
                        title="ATTACHMENT"
                        totalFiles={3}
                        isAmending={true}                        
                        maxLength={15}
                        fetchFileData={this.fetchFileData}
                        files={contractForm.contract.files}
                        fileSizeMBStr="10"
                    />
                    </div>
                   

                </div>

                <div className="horizontal-separator"></div>
                <ContractCommitment 
                    translator={(x) => this.toLocaleLanguage(x)}
                    toggleDropdown={this.handleToggleDropdown}
                    activeDropdown={this.state.activeDropdown}
                    contractForm={contractForm}
                    isReadAndWrite={true}

                />


                <div className='dispute-save-btn save-btn-container'>
                    <ConfirmationModal
                        ref={this.ConfirmationModal}
                        title={this.state.saveModal.title}
                        messageBody={this.state.saveModal.messageBody}
                        confirmAction={this.state.saveModal.confirmAction}
                        closeLabel={this.toLocaleLanguage("cancel_button", false)}
                        confirmLabel={this.toLocaleLanguage("yes_button", false)}
                        disabled={this.state.isSaving}
                    />

                    <NotificationModal
                        show={this.state.saveNotif.show}
                        title={this.state.saveNotif.title}
                        message={this.state.saveNotif.message}
                        handleModal={() => this.toggleSaveNotif(false)}
                        customClass={'comment-notification-modal modal-text-bold notification-footer'}
                    />

                    
                    <div className="tooltip-container">
                        <div className="btn-tooltiptext">
                            {this.props.isReadAndWrite &&
                                <Button
                                    className='save-details-btn btn btn-primary'
                                    disabled={this.props.isCreateNew ? enableSaveButton : this.disableSaveChanges()}
                                    type="button"
                                    onClick={() => this.handleButtonConfirmation(contractId)}>
                                    Save Changes
                                </Button>
                            }
                            <div className="save-tooltip-text-container">
                                <span className="tooltip-text-save">{this.toLocaleLanguage("save_contract_details")}</span>
                            </div>

                        </div>
                    </div> 
                 
                </div>
            </div>
            }
            </>     
        )
    }
}

export default withRouter(connect(
    state => {
        const { contractDetails, translation } = state;
        const { contractForm, forms: { contractForm: { $form } } } = state.form;
        return {
            ...translation,
            contractDetails,
            contractForm,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, FinanceContractFormActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(ContractFormView));